// Recommended Jobs
const Recommendedjob = [
    {
        id: '1',
        position: 'Assistant / Store Keeper',
        c_name: 'Moetic Fashion',
        location: 'Limestone, US',
        salary: '$340 - $800',
        experience: '0-3 year',
        job_type: 'Internship'
    },
    {
        id: '2',
        position: 'Education Training',
        c_name: 'Micro Design',
        location: 'Germany',
        salary: '$750 - $940',
        experience: '1.5+ year',
        job_type: 'Freelancer'
    },
    {
        id: '3',
        position: 'Executive, HR Operations',
        c_name: 'Micro Design',
        location: 'Texanna, US',
        salary: '$50 - $120',
        experience: '1-5 year',
        job_type: 'Part Time'
    },
    {
        id: '4',
        position: 'Full Stack Engineer',
        c_name: 'Syntyce Solutions',
        location: 'Zuweihir, UAE',
        salary: '$650 - $900',
        experience: '0-1+ year',
        job_type: 'Full Time'
    },
    {
        id: '5',
        position: 'Full Stack Engineer',
        c_name: 'Force Medicines',
        location: 'Ugashik, US',
        salary: '$120 - $180',
        experience: '2-5 year',
        job_type: 'Part Time'
    },
    {
        id: '6',
        position: 'Full Stack Engineer',
        c_name: 'Digitech Galaxy',
        location: 'Maidaq, UAE',
        salary: '$900 - $1020',
        experience: '3-5 year',
        job_type: 'Full Time'
    },
    {
        id: '7',
        position: 'Graphic Designer',
        c_name: 'Digitech Galaxy',
        location: 'Mughairah, UAE',
        salary: '$160 - $230',
        experience: '2-3+ year',
        job_type: 'Full Time'
    },
    {
        id: '8',
        position: 'Marketing Director',
        c_name: 'Meta4Systems',
        location: 'Vinninga, Sweden',
        salary: '$250 - $800',
        experience: '0-5 year',
        job_type: 'Full Time'
    },
    {
        id: '9',
        position: 'Marketing Director',
        c_name: 'Zoetic Fashion',
        location: 'Quesada, US',
        salary: '$600 - $870',
        experience: '0-5 year',
        job_type: 'Freelancer'
    },
    {
        id: '10',
        position: 'Project Manager',
        c_name: 'Themesbrand',
        location: 'California, US',
        salary: '$400 - $600',
        experience: '3+ year',
        job_type: 'Part Time'
    },
    {
        id: '11',
        position: 'Project Manager',
        c_name: 'Meta4Systems',
        location: 'Limestone, US',
        salary: '$210 - $300',
        experience: '0-2+ year',
        job_type: 'Freelancer'
    },
    {
        id: '12',
        position: 'React Developer',
        c_name: 'iTest Factory',
        location: 'Khabākhib, UAE',
        salary: '$90 - $160',
        experience: '5+ year',
        job_type: 'Internship'
    },
    {
        id: '13',
        position: 'UI/UX designer',
        c_name: 'Zoetic Fashion',
        location: 'Cullera, Spain',
        salary: '$400+',
        experience: '0-2 year',
        job_type: 'Part Time'
    },
    {
        id: '14',
        position: 'Web Designer',
        c_name: 'Force Medicines',
        location: 'Ugashik, US',
        salary: '$412 - $241',
        experience: '3+ year',
        job_type: 'Freelancer'
    }
]

// Popular Candidate
const jobcandidate = [
    {
        id: '1',
        image: 'assets/images/users/avatar-10.jpg',
        name: 'Tonya Noble',
        insta: 'tonya',
        designation: 'Web Developer'
    },
    {
        id: '2',
        image: 'assets/images/users/avatar-1.jpg',
        name: 'Nicholas Ball',
        insta: 'nicholas',
        designation: 'Assistant / Store Keeper'
    },
    {
        id: '3',
        image: 'assets/images/users/avatar-9.jpg',
        name: 'Zynthia Marrow',
        insta: 'zynthia',
        designation: 'Full Stack Engineer'
    },
    {
        id: '4',
        image: 'assets/images/users/avatar-2.jpg',
        name: 'Cheryl Moore',
        insta: 'Cheryl',
        designation: 'Product Designer'
    },
    {
        id: '5',
        image: 'assets/images/users/avatar-5.jpg',
        name: 'Jennifer Bailey',
        insta: 'Jennifer',
        designation: 'Marketing Director'
    },
    {
        id: '6',
        image: 'assets/images/users/avatar-8.jpg',
        name: 'Hadley Leonard',
        insta: 'hadley',
        designation: 'Executive, HR Operations'
    }
]

export { Recommendedjob, jobcandidate }